export function setName(state, data) {
  state.name = data;
}
export function setAccount(state, data) {
  state.account = data;
}
export function setAccountCategory(state, data) {
  state.accountCategory = data;
}
export function setBusinessId(state, data) {
  state.business_id = data;
}
export function setModel(state, data) {
  state.model = data;
}
